import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";

import SimpleMessageDialog from "../../../components/SimpleMessageDialog";
import RenewalListingTable from "./Dashboard/RenewalListingTable";
import RenewalSelectRequest from "./Dashboard/RenewalSelectRequest";
import RenewalUploadForms from "./Dashboard/RenewalUploadForms";

import RenewalSubmissionListingTable from "./Dashboard/RenewalSubmissionListingTable";
import { renewalActions } from "../../../actions";
import { documentActions } from "../../../actions";
import PolicyRenewalSteps from "./PolicyRenewalSteps";

import { withStyles } from "@mui/styles";
import CustomBreadcrumb from "../../../components/CustomBreadcrumb";
import { Typography } from "@mui/material";
import LoadingPopup from "../../../components/LoadingPopup";
import RenewalSubmission from "./Dashboard/RenewalSubmission";
import RenewalSubmittedDocuments from "./Dashboard/RenewalSubmittedDocuments";

class Renewal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMessageDialog: false,
      errorMessage: "",
      searchInputValue: "",
      currentPageNo: 0,
      activeStep: 1,
      selectedPolicy: this.props.policyRenew.policy_no == "" ? null : this.props.policyRenew.policy_no,
      renewalType: this.props.policyRenew.renewal_type == "" ? null : this.props.policyRenew.renewal_type,
      renewalTypeOptions: [],
      isRenewalBtnDiabled: true,
      isSubmitBtnDiabled: true,
      files: [],
      errors: {},
      renewals: [], // Placeholder for renewal data
      renewalSubmissions: [], // Placeholder for renewal submission data
      renewalPage: "",
      hasStepSet: false,
      previousRenewalType: "", //store the lastes selected renewal type
      previousSubRenewalType: "", //store the latest selected sub renewal type
      previousRenewalId: "", //store the lastest existing_renewal_id
      previousDocumentData: [], // keeping the already selected documents on step3
      checkSubmitButton: false, //using this to check submit button disable condition
      checkNextButton: false, //using this to checknext button disable condition
      subRenewalTypeOptions: []  // options for sub renewal type
    };
  }

  getStepFromQuery = () => {
    const query = new URLSearchParams(this.props.location.search);
    let id = query.get("id");
    if (id != 1 && this.state.hasStepSet) {
      this.setState({
        hasStepSet: false
      });
      // let path = `${this.props.location.pathname}?id=${this.state.activeStep + 1}`
      // this.props.history.push(path);
    }
    if (id == 1 && !this.state.hasStepSet) {
      this.setState({
        activeStep: 1,
        hasStepSet: true
      });
    }
  };

  setStepFromQuery = () => {
    const query = new URLSearchParams(this.props.location.search);
    let id = query.get("id");
    if (id && !this.state.hasStepSet) {
      this.setState({
        activeStep: parseInt(id)
        // hasStepSet: true
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.document.renewalFiles.length && !this.state.checkSubmitButton) {
      this.setIsSubmitBtnDisabled();
      this.setState({
        checkSubmitButton: true
      });
    }

    // Re-validate and disable submit button when renewal files are cleared
    if (prevProps.document.renewalFiles.length > 0 && this.props.document.renewalFiles.length === 0) {
      this.setState({
        isSubmitBtnDiabled: true,
        checkSubmitButton: false  // Reset flag so it can re-evaluate when files are added again
      });
    }

    if (this.state.selectedPolicy && !this.state.checkNextButton) {
      this.setState({
        isRenewalBtnDiabled: false,
        checkNextButton: true
      });
    }
    this.getStepFromQuery();

    // Refresh list and reset Redux when entering step 1
    if (this.state.activeStep === 1 && prevState.activeStep !== 1) {
      // Reset policyRenew in Redux
      this.props.resetRenewal();
      this.props.documentActions.clearRenewalFiles();
      
      // Call API to refresh the renewal policies list
      this.props.getRenewPolicies().then(res => {
        this.setState({
          renewals: [...this.props.renewalPolicies.pendingList],
          renewalSubmissions: [...this.props.renewalPolicies.submmitedList],
          selectedPolicy: null,
          renewalType: null,
          isRenewalBtnDiabled: true,
          checkNextButton: false
        });
      });
    }

    // Refresh sub-renewal options when navigating back to step 2
    if (this.state.activeStep === 2 && prevState.activeStep === 3) {
      const { policyRenew } = this.props;
      
      // Check if we need to show sub-renewal options
      const shouldShowSubOptions = (
        (["PF2", "PF3", "PTF"].includes(policyRenew.contract_type) && policyRenew.is_full_declaration !== "Y") ||
        (policyRenew.is_full_declaration !== "Y" && policyRenew.renewal_type === "RENEW")
      );
      
      if (shouldShowSubOptions && policyRenew.renewal_type) {
        this.setState({
          subRenewalTypeOptions: [
            {
              name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
              value: "WITH_CHANGE_SIGNATORY"
            },
            {
              name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
              value: "WITHOUT_CHANGE_SIGNATORY"
            }
          ],
          // Enable Next button if sub-renewal type is already selected
          isRenewalBtnDiabled: !policyRenew.sub_renewal_type
        });
      }
    }

    // Validate forms when entering step 3 or when relevant data changes
    if (this.state.activeStep === 3) {
      const hasHrDecChanged = prevProps.policyRenew.has_hr_dec_changed !== this.props.policyRenew.has_hr_dec_changed;
      const renewalTypeChanged = prevProps.policyRenew.renewal_type !== this.props.policyRenew.renewal_type;
      const filesChanged = prevProps.document.renewalFiles.length !== this.props.document.renewalFiles.length;
      const justEnteredStep3 = prevState.activeStep !== 3;

      if (hasHrDecChanged || renewalTypeChanged || filesChanged || justEnteredStep3) {
        // Clear errors first, then validate
        this.setState({ errors: {} }, () => {
          this.validateForms();
        });
      }
    }
  }

  componentWillMount() {
    this.setStepFromQuery();
    const { policyRenew } = this.props;
    if (policyRenew.id) this.props.documentActions.getRenewalFiles(policyRenew.id);
    this.validateForms();
  }

  componentDidMount() {
    this.state.renewalPage = "step0";
    const { policyRenew } = this.props;


    // Reset Redux when first arriving at step 1 from another module
    if (this.state.activeStep === 1) {
      this.props.resetRenewal();
      this.props.documentActions.clearRenewalFiles();
      this.setState({
        selectedPolicy: null,
        renewalType: null
      });
    }

    if (this.state.activeStep == 2 || this.state.activeStep == 3) {
      if (["PF2", "PF3", "PTF"].includes(policyRenew.contract_type)) {
        this.setState({
          renewalTypeOptions: [
            {
              name: "Renew without changes at the policy level - benefits and member details",
              value: "RENEW_WITHOUT_CHG"
            },
            {
              name: "Renew with changes at the policy level - benefits or member details",
              value: "RENEW_WITH_CHG"
            }
          ]
        });

        // Check if renewal type is pre-selected and show sub-options if needed
        const shouldShowSubOptions = ["PF2", "PF3", "PTF"].includes(policyRenew.contract_type) && 
                                      policyRenew.is_full_declaration !== "Y";
        
        if (shouldShowSubOptions && 
            this.state.renewalType && 
            (this.state.renewalType === "RENEW_WITH_CHG" || this.state.renewalType === "RENEW_WITHOUT_CHG")) {
          this.setState({
            subRenewalTypeOptions: [
              {
                name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
                value: "WITH_CHANGE_SIGNATORY"
              },
              {
                name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
                value: "WITHOUT_CHANGE_SIGNATORY"
              }
            ],
            // If sub-options should be shown, disable Next button until sub-selection is made
            isRenewalBtnDiabled: true
          });
        }

      } else {
        this.setState({
          renewalTypeOptions: [
            {
              name: "Renew",
              value: "RENEW"
            }
          ]
        });

        // Check if "RENEW" is pre-selected and show sub-options if needed
        const shouldShowSubOptions = policyRenew.is_full_declaration !== "Y";
        
        if (shouldShowSubOptions && this.state.renewalType === "RENEW") {
          this.setState({
            subRenewalTypeOptions: [
              {
                name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
                value: "WITH_CHANGE_SIGNATORY"
              },
              {
                name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
                value: "WITHOUT_CHANGE_SIGNATORY"
              }
            ],
            isRenewalBtnDiabled: true
          });
        }
      }
    }
    if (policyRenew.id) {
      this.props.documentActions.getRenewalFiles(policyRenew.id).then(document => {
        this.setState({
          previousDocumentData: [...document.value.data.data]
        });
      });
    }

    this.props.getRenewPolicies().then(res => {
      this.state.renewalPage = "step1";
      this.setState({
        renewals: [...this.props.renewalPolicies.pendingList],
        renewalSubmissions: [...this.props.renewalPolicies.submmitedList]
      });
    });
    // this.props.getRenewSubmissionList();

    // Simulate fetching data
    const { activeStep, selectedPolicy, renewalType } = this.state;
    if (activeStep === 1) {
      this.setState({
        isRenewalBtnDiabled: selectedPolicy === null
      });
    } else if (activeStep === 2) {
      this.setState({
        isRenewalBtnDiabled: renewalType === null
      });
    }

    this.setState({
      renewals: [...this.props.renewalPolicies.pendingList],
      renewalSubmissions: [...this.props.renewalPolicies.submmitedList]
    });
  }

  handleErrorInput = errorMessage => {
    this.setState({
      errorMessage: errorMessage,
      openMessageDialog: true
    });
  };

  handleCloseMessageDialog = () => {
    this.setState({ errorMessage: "", openMessageDialog: false });
  };

  handleRadioChange = (event, details) => {
    if (this.state.activeStep === 1) {
      this.setState({
        selectedPolicy: event.target.value,
        isRenewalBtnDiabled: false,
        renewalType: details?.renewal_type,
        subRenewalTypeOptions: [],  // ADD THIS LINE - Clear sub-options
        // Reset previous values when selecting a new policy
        previousRenewalType: "",
        previousSubRenewalType: "",
        previousRenewalId: ""
      });
      this.props.setRenewalType({
        renewal_type: details?.renewal_type
      });
      this.props.setRenewal(details);
    } else if (this.state.activeStep === 2) {

      const { policyRenew } = this.props;
      const shouldShowSubOptions = (
        (["PF2", "PF3", "PTF"].includes(policyRenew.contract_type) && policyRenew.is_full_declaration !== "Y") ||
        (policyRenew.is_full_declaration !== "Y" && event.target.value === "RENEW")
      );
      
      // Determine if Next button should be disabled based on whether sub-options are needed
      const needsSubSelection = shouldShowSubOptions && 
                                (event.target.value === "RENEW_WITH_CHG" || 
                                  event.target.value === "RENEW_WITHOUT_CHG" || 
                                  event.target.value === "RENEW");
      
      this.setState({ 
        renewalType: event.target.value, 
        isRenewalBtnDiabled: needsSubSelection
      });

      // Reset sub renewal type in Redux when renewal type changes
      this.props.setSubRenewalType({
        sub_renewal_type: ""
      });
      
      this.props.setRenewalType({
        renewal_type: event.target.value
      });
      
      // Set up sub-options if needed
      if (shouldShowSubOptions && (event.target.value === "RENEW_WITH_CHG" || event.target.value === "RENEW_WITHOUT_CHG" || event.target.value === "RENEW")) {
        this.setState({
          subRenewalTypeOptions: [
            {
              name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
              value: "WITH_CHANGE_SIGNATORY"
            },
            {
              name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
              value: "WITHOUT_CHANGE_SIGNATORY"
            }
          ]
        });
      } else {
        this.setState({
          subRenewalTypeOptions: []
        });
      }

    }
  };

  handleSubRadioChange = (event) => {
    const value = event.target.value;
    // UPDATE: Use Redux action instead of local state
    this.props.setSubRenewalType({
      sub_renewal_type: value
    });

    this.setState({ 
      //subRenewalType: value,
      isRenewalBtnDiabled: false
    });
    
    // Set has_hr_dec_changed based on sub-selection
    if (value === "WITH_CHANGE_SIGNATORY") {
      this.props.setHasHrDecChanged(true);
    } else if (value === "WITHOUT_CHANGE_SIGNATORY") {
      this.props.setHasHrDecChanged(false);
    }
  };

  handleNext = () => {
    const { policyRenew, renewalPolicies } = this.props;
    if (this.state.activeStep === 1) {
      this.state.renewalPage = "step1";
      //calling document api if policy id is null
      if (this.props.policyRenew?.id) {
        this.props.documentActions.getRenewalFiles(this.props.policyRenew.id).then(document => {
          this.setIsSubmitBtnDisabled();
        });
      }
      if (["PF2", "PF3", "PTF"].includes(policyRenew.contract_type)) {
        this.setState({
          renewalTypeOptions: [
            {
              name: "Renew without changes at the policy level - benefits and member details",
              value: "RENEW_WITHOUT_CHG"
            },
            {
              name: "Renew with changes at the policy level - benefits or member details",
              value: "RENEW_WITH_CHG"
            }
          ]
        });

        // Check if renewal type is pre-selected and show sub-options if needed
        const shouldShowSubOptions = ["PF2", "PF3", "PTF"].includes(policyRenew.contract_type) && 
                                      policyRenew.is_full_declaration !== "Y";
        
        if (shouldShowSubOptions && 
            this.state.renewalType && 
            (this.state.renewalType === "RENEW_WITH_CHG" || this.state.renewalType === "RENEW_WITHOUT_CHG")) {
          this.setState({
            subRenewalTypeOptions: [
              {
                name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
                value: "WITH_CHANGE_SIGNATORY"
              },
              {
                name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
                value: "WITHOUT_CHANGE_SIGNATORY"
              }
            ]
          });
        }

      } else {
        this.setState({
          renewalTypeOptions: [
            {
              name: "Renew",
              value: "RENEW"
            }
          ]
        });

        // Check if "RENEW" is pre-selected and show sub-options if needed
        const shouldShowSubOptions = policyRenew.is_full_declaration !== "Y";
        
        if (shouldShowSubOptions && this.state.renewalType === "RENEW") {
          this.setState({
            subRenewalTypeOptions: [
              {
                name: "Change in either Authorized Signatory or Director/Shareholder (ACRA, MAS314, and Authorized Signatory's ID documents are mandatory)",
                value: "WITH_CHANGE_SIGNATORY"
              },
              {
                name: "No change in Authorized Signatory or Director/Shareholder (HR declaration form required)",
                value: "WITHOUT_CHANGE_SIGNATORY"
              }
            ]
          });
        }
      }
      // Determine if sub-selection is required and not yet made
      const { policyRenew: updatedPolicyRenew } = this.props;
      const shouldShowSubOptions = (
        (["PF2", "PF3", "PTF"].includes(policyRenew.contract_type) && policyRenew.is_full_declaration !== "Y") ||
        (policyRenew.is_full_declaration !== "Y" && this.state.renewalType === "RENEW")
      );
      const needsSubSelection = shouldShowSubOptions && 
                                (this.state.renewalType === "RENEW_WITH_CHG" || 
                                 this.state.renewalType === "RENEW_WITHOUT_CHG" || 
                                 this.state.renewalType === "RENEW");
      this.setState({
        isRenewalBtnDiabled: (this.state.renewalType === null || this.state.renewalType === undefined) ||
                              (needsSubSelection && !policyRenew.sub_renewal_type)
      });
    } else if (this.state.activeStep === 2) {
      this.setIsSubmitBtnDisabled();
      const details = this.mapBodyForCreatePolicy(policyRenew);
      if (policyRenew.id) {
        this.props.renewalPolicies.pendingList.map(item => {
          if (item.id === policyRenew.id || policyRenew.id == this.state.previousRenewalId) {
            // Ignore sub_renewal_type changes when is_full_declaration is "Y"
            const shouldCheckSubRenewalType = policyRenew.is_full_declaration !== "Y";

            if (
              (policyRenew.renewal_type !== item.renewal_type && this.state.previousRenewalType == "") ||
              (this.state.previousRenewalType && policyRenew.renewal_type !== this.state.previousRenewalType) ||
              (shouldCheckSubRenewalType && this.state.previousSubRenewalType && policyRenew.sub_renewal_type !== this.state.previousSubRenewalType) ||
              (shouldCheckSubRenewalType && !this.state.previousSubRenewalType && policyRenew.sub_renewal_type !== item.sub_renewal_type)
            ) {
              details.existing_renewal_id = policyRenew.id;
            } else {
              this.setState({
                activeStep: this.state.activeStep + 1
              });
              //updating the path based on step number
              let path = `${this.props.location.pathname}?id=${this.state.activeStep + 1}`;
              this.props.history.push(path);
            }
          }
        });
      } else {
        this.props
          .createRenewal(details)
          .then(res => {
            this.state.renewalPage = "step2";
            this.props.setRenewalId(res.value.data.data.id);
            this.props.setRenewalStatus("DRAFT");
            this.setState({
              activeStep: this.state.activeStep + 1,
              previousRenewalType: this.state.renewalType,
              previousSubRenewalType: policyRenew.sub_renewal_type,
              previousRenewalId: res.value.data.data.id
            });
            //updating the path based on step number
            if (this.state.activeStep == 2) {
              let path = `${this.props.location.pathname}?id=${this.state.activeStep + 1}`;
              this.props.history.push(path);
            } else {
              let path = `${this.props.location.pathname}?id=${this.state.activeStep}`;
              this.props.history.push(path);
            }
          })
          .catch(err => {
            this.handleErrorInput(err?.message);
          });
      }
      //we were calling the createRenewal api here.
      if (details.existing_renewal_id) {
        this.props
          .createRenewal(details)
          .then(res => {
            this.state.renewalPage = "step2";
            this.props.setRenewalId(res.value.data.data.id);
            this.props.setRenewalStatus("DRAFT");

            // CLEAR renewal files when new renewal is created with existing_renewal_id
            this.props.documentActions.clearRenewalFiles();

            this.setState({
              activeStep: this.state.activeStep + 1,
              previousRenewalType: this.state.renewalType,
              previousSubRenewalType: policyRenew.sub_renewal_type,
              previousRenewalId: res.value.data.data.id
            });
            //updating the path based on step number
            let path = `${this.props.location.pathname}?id=${this.state.activeStep}`;
            this.props.history.push(path);
          })
          .catch(err => {
            this.handleErrorInput(err?.message);
          });
      }
    }
    if (this.state.renewalPage?.length && this.state.activeStep == 1) {
      this.setState({
        activeStep: this.state.activeStep + 1
      });
      let path = `${this.props.location.pathname}?id=${this.state.activeStep + 1}`;
      this.props.history.push(path);
    }
    this.state.renewalPage = "";
  };

  renewTypeChanged = () => {};

  handleSubmit = () => {

    // Disable submit button immediately
    this.setState({
      isSubmitBtnDiabled: true
    });

    this.validateForms();
    if (this.isValid().valid) {
      this.props.setRenewalStatus("SUBMITTED");
      let details = this.mapBodyForCreatePolicy(this.props.policyRenew);
      details.status = "SUBMITTED";
      this.props
        .putRenewalPolicy(this.props.policyRenew.id, details)
        .then(res => {
          this.setState({
            activeStep: this.state.activeStep + 1
          });
          let path = `${this.props.location.pathname}?id=${this.state.activeStep + 1}`;
          this.props.history.push(path);
        })
        .catch(err => {
          // Re-enable button only on error so user can retry
          this.setState({
            isSubmitBtnDiabled: false
          });
          this.handleErrorInput(err?.message);
        });
    } else {
      // Re-enable button if validation fails
      this.setState({
        isSubmitBtnDiabled: false
      });
    }
  };

  setIsSubmitBtnDisabled = isChecked => {
    this.setState({
      isSubmitBtnDiabled: !this.isValid(isChecked).valid
    });
  };

  onRemoveFile = () => {
    this.setIsSubmitBtnDisabled();
  };

  checkActiveStep = () => {
    if (this.state.activeStep == 2) {
      this.state.renewalPage = "step1";
    } else if (this.state.activeStep == 3) {
      this.state.renewalPage = "";
    }
  };

  handleSave = () => {console.log("handleSave");
    let details = this.mapBodyForCreatePolicy(this.props.policyRenew);
    if (this.state.activeStep === 3) {
      console.log("handleSave - setting DRAFT");
      this.props.setRenewalStatus("DRAFT");
      details.status = "DRAFT";  // Set directly instead of reading from Redux
    } else {
      details.status = this.props.policyRenew.status;  // Keep original status for other steps
    }

    // let details = this.mapBodyForCreatePolicy(this.props.policyRenew);
    // details.status = this.props.policyRenew.status;
    console.log("details", details);

    if (this.state.activeStep === 3) {
      this.props.putRenewalPolicy(this.props.policyRenew.id, details);
    } 
      this.setState({
        activeStep: this.state.activeStep - 1,
        subRenewalTypeOptions: []
      });

    this.state.isRenewalBtnDiabled = false;
    let path = `${this.props.location.pathname}?id=${this.state.activeStep - 1}`;
    this.props.history.push(path);
    this.checkActiveStep();
  };

  mapBodyForCreatePolicy(policy_renew) {
    return {
      company_name: policy_renew.company_name,
      policy_no: policy_renew.policy_no,
      expiry_date: policy_renew.expiry_date,
      renewal_type: policy_renew.renewal_type,
      contract_type: policy_renew.contract_type,
      has_hr_dec_changed: policy_renew.has_hr_dec_changed,
      is_full_declaration: policy_renew.is_full_declaration, 
      // If is_full_declaration is "Y", set sub_renewal_type to null
      sub_renewal_type: policy_renew.is_full_declaration === "Y" ? null : policy_renew.sub_renewal_type
    };
  }

  getPageTitle() {
    switch (this.state.activeStep) {
      case 1:
        return "Policy Renewal";
      case 2:
        return "Submit a request for Renewal";
      case 3:
        return "Submit a request for Renewal";
      case 4:
        return "Your Request for Renewal has been successfully submitted";
      case 5:
        return "Request for Renewal";
      default:
        return "";
    }
  }

  getBreadCrumbTitle() {
    switch (this.state.activeStep) {
      case 1:
        return "Renewal";
      case 2:
        return "RequestForRenewal";
      case 3:
        return "RequestForRenewal";
      case 4:
        return "RequestForRenewal";
      case 5:
        return "RequestForRenewal";
      default:
        return "";
    }
  }

  getPrefix(renewalType) {
    if (renewalType === "RENEW_WITHOUT_CHG") {
      return "RWOC_";
    } else if (renewalType === "RENEW_WITH_CHG") {
      return "RWC_";
    } else {
      return "RWCC_";
    }
  }

  setUploadFormErrors(error) {
    const { errors } = this.state;
    this.setState(prevState => {
      const updatedErrors = {
        ...prevState.errors,
        ...error
      };
      return {
        errors: updatedErrors
      };
    });
  }

  validateForms() {
    const { errors, renewalType } = this.state;
    // get all file types

    const errorMessages = {
      LETTER: "Renewal invitation letter is required",
      HR_DEC: "HR Declaration on Shareholders and Directorship is required",
      DEC_ENTITLEMENT: "Declaration of Entitlement to Claim Input Tax on Insurance Policy is required",
      DEC_SPECIFIC: "Declaration of Specific Individual is required",
      ACRA: "ACRA Document is required",
      MAS314: "MAS314 is required",
      AUTHO_SIGNATORY: "Authorized Signatory ID is required"
    };

    // getRenewalType
    if (!this.isValid().valid) {
      this.isValid().missingForms.map(type => {
        let messageType = this.getPrefix(renewalType) + type;
        this.setUploadFormErrors({
          [messageType]: {
            dialogDescription: errorMessages[type]
          }
        });
      });
    }
  }

  isValid(isChecked) {
    const { document, policyRenew } = this.props;
    const { errors, renewalType } = this.state;
    let fileTypes = [];
    document.renewalFiles.map(item => {
      fileTypes.push(item.file_type);
    });
    let mandatoryForms = [];
    if (policyRenew.has_hr_dec_changed || isChecked) {
      mandatoryForms = ["LETTER", "DEC_ENTITLEMENT", "DEC_SPECIFIC", "ACRA", "MAS314", "AUTHO_SIGNATORY"];
    } else {
      mandatoryForms = ["LETTER", "HR_DEC", "DEC_ENTITLEMENT", "DEC_SPECIFIC"];
    }
    let missingForms = mandatoryForms.filter(item => !fileTypes.includes(`${this.getPrefix(renewalType)}${item}`));
    if (missingForms.length === 0) {
      return {
        valid: true
      };
    } else {
      return {
        valid: false,
        missingForms: missingForms
      };
    }
  }

  render() {
    const { classes, showLoadingPopup, navDrawerOpen, setHasHrDecChanged } = this.props;
    const { activeStep, selectedPolicy, renewalType, renewalTypeOptions, errors } = this.state;
    return (
      <div className={classes.root}>
        <LoadingPopup title="Loading..." open={showLoadingPopup} />
        <div className={classes.breadcrumb}>
          <CustomBreadcrumb currentPage={this.getBreadCrumbTitle()} />
        </div>
        <Typography className={classes.title}>{this.getPageTitle()}</Typography>

        <SimpleMessageDialog
          type="error"
          title="Error"
          description={this.state.errorMessage}
          closeHandler={this.handleCloseMessageDialog}
          open={this.state.openMessageDialog}
          closeButtonText="Close"
        />
        {activeStep == 1 && (
          <>
            <RenewalListingTable
              handleRadioChange={this.handleRadioChange}
              selectedPolicy={selectedPolicy}
              // handleErrorInput={this.handleErrorInput}
              renewals={this.state.renewals}
            />
            <RenewalSubmissionListingTable renewalSubmissions={this.state.renewalSubmissions} />
          </>
        )}

        {
        activeStep == 2 && (
          <RenewalSelectRequest
            renewalTypeOptions={renewalTypeOptions}
            // renewalType={renewalType}
            renewalType={this.props.policyRenew.renewal_type} 
            handleRadioChange={this.handleRadioChange}
            subRenewalTypeOptions={this.state.subRenewalTypeOptions}
            //subRenewalType={this.state.subRenewalType}
            subRenewalType={this.props.policyRenew.sub_renewal_type}  // CHANGE: Get from Redux
            handleSubRadioChange={this.handleSubRadioChange}
            policyRenew={this.props.policyRenew}
          />
        )}
        {activeStep == 3 && (
          <RenewalUploadForms
            documentActions={this.props.documentActions}
            files={this.props.document.renewalFiles}
            prefix={this.getPrefix(renewalType)}
            renewalType={renewalType}
            setHasHrDecChanged={setHasHrDecChanged}
            errors={errors}
            setUploadFormErrors={this.setUploadFormErrors.bind(this)}
            setIsSubmitBtnDisabled={this.setIsSubmitBtnDisabled}
            onRemoveFile={this.onRemoveFile}
            subRenewalType={this.props.policyRenew.sub_renewal_type}  // Get from Redux
          />
        )}
        {activeStep == 4 && <RenewalSubmission />}
        {activeStep == 5 && <RenewalSubmittedDocuments />}

        {activeStep != 4 && (
          <PolicyRenewalSteps
            activeStep={activeStep}
            navDrawerOpen={navDrawerOpen}
            isRenewalBtnDiabled={this.state.isRenewalBtnDiabled}
            isSubmitBtnDiabled={this.state.isSubmitBtnDiabled}
            handleNext={this.handleNext}
            handleSave={this.handleSave}
            handleSubmit={this.handleSubmit}
          />
        )}
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    overflowX: "auto",
    padding: "0px 25px"
  },
  breadcrumb: {
    padding: "30px 0px 30px 0px"
  },
  title: {
    fontSize: "24px",
    fontWeight: "600 !important",
    padding: "10px 0px 20px 0px"
  },
  description: {
    fontSize: "16px",
    padding: "0px 0px 20px 0px"
  },
  font: {
    fontWeight: "600 !important"
  },
  searchButton: {
    height: "2.7rem",
    width: "8rem",
    backgroundColor: theme.colors.primary.red,
    color: theme.palette.common.white
  },
  searchInput: {
    width: "100%"
  }
});

function mapStateToProps(state) {
  return {
    renewalList: state.renewalList,
    renewalSubmissionList: state.renewalSubmissionList,
    showLoadingPopup: state.app.showLoadingPopup,
    renewalPolicies: state.renewPolicies,
    policyRenew: state.policyRenew,
    document: state.document
  };
}

function mapDispatchToProps(dispatch) {
  return {
    documentActions: bindActionCreators(documentActions, dispatch),
    ...bindActionCreators(renewalActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withStyles(styles, { withTheme: true })(Renewal)));
